import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import { tailwindMerge } from "@air/tailwind-variants";
export const ContentCollectionActionBar = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx("div", {
            className: tailwindMerge("fixed bottom-5 right-5 flex h-14 w-[calc(100%-372px-12px-20px)] items-center justify-between rounded-lg bg-grey-1 px-2 dark:border dark:border-grey-5", className),
            "data-theme": "dark",
            ...restOfProps
        })
    });
};
